<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 px-2 text-center">
      <h2 class="pb-3 text-center" style="line-height: 1.25">Welcome 
        <span style="white-space: nowrap;">{{ pro_user.name }}!</span>
      </h2>
      <p>
        You have been invited to join the 
        <span style="white-space: nowrap;">{{ pro_user.pro.business_name }}</span> account.
      </p>
      <p>
        By creating this user, you will now receive notifications and will be
        able to claim leads on this account. Speed Wins!
      </p>
    </div>
    
    <div class="mt-4 px-2 text-center primary--text">
      <h2>{{ leadMessage }}</h2>
    </div>

    <div class="mt-6 mb-3 d-flex justify-center">
      <v-btn width="60%" type="submit" color="primary" @click="verifyClick">
        Create your user
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnclaimedUserView',

  props: ['claim_token', 'pro_user'],

  computed: {
    leadMessage() {
      const { lead_count } = this.pro_user
      if (lead_count < 1) 
        return 'Start collecting leads now!'

      if(lead_count == 1) 
        return 'You have a lead waiting!'

      return `You have ${ lead_count } leads waiting.`
    },
  },

  methods: {
    async verifyClick() {
      this.$router.replace ( { name: 'claim/verify'} )
    },
  },
}
</script>